module.exports = __webpack_public_path__ + "img/pos5-bg.d6b2fcce.jpg";